import { useTranslation } from "react-i18next";
import { get, useFormContext, useFormState } from "react-hook-form";
import {FormHelperText, FormLabel, Stack} from "@mui/material";
import React from "react";
import FileUploader from "../../../../../../../util/component/FileUploader";
import { IFormValues } from "../../../types";

const AssetUploader = (props: any) => { // todo define interface
    /**
     * interfaccia props:
     * field: string
     * label: string - già tradotta
     * required: boolean
     **/

    const { t } = useTranslation('booking');

    const formContext: any = useFormContext<IFormValues>();
    const formState = useFormState<IFormValues>();

    const errors = formState.errors;

    const handleUpload = async (file: File) => {
        formContext.setValue(`assets.${props.field}`, file);
    }
    const handleRemove = () => {
        formContext.setValue(`assets.${props.field}`, null);
    }

    return (
      <>
          <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              pb={1}
          >
              <FormLabel
                  required={props.required}
                  error={!!get(errors, `assets.${props.field}`)}
              >
                  {`${props.label}`}
              </FormLabel>
              {/*                            <IconButton
                                title={t('customerData.button.viewDocument')}
                                onClick={idDocFrontDialog.handleShow}
                                disabled={!idDocFront}
                            >
                                <VisibilityRounded />
                            </IconButton>*/}
          </Stack>
          {/*                        <Dialog
                            open={idDocFrontDialog.open}
                            onClose={idDocFrontDialog.handleClose}
                            fullWidth
                            maxWidth="lg"
                        >
                            <DialogContent>
                                <img
                                    src={idDocFront ? URL.createObjectURL(idDocFront) : undefined}
                                    alt=""
                                    width="100%"
                                />
                            </DialogContent>
                        </Dialog>*/}
          <FileUploader
              /*uploadedFiles={idDocFront ? [idDocFront] : []}*/
              onUpload={handleUpload}
              onRemove={handleRemove}
              acceptedFiles={{
                  'image/png': ['.pdf','.png', '.jpeg', '.jpg']
              }}
          />
          { !!formContext.formState.errors?.assets && !!formContext.formState.errors?.assets[`${props.field}`] &&
              <FormHelperText
                  error
              >
                  {t(formContext.formState.errors?.assets[`${props.field}`].message)}
              </FormHelperText>
          }
      </>
    );
}

export default AssetUploader;
